import { render, staticRenderFns } from "./multiconnect.vue?vue&type=template&id=1247b000&"
import script from "./multiconnect.vue?vue&type=script&lang=js&"
export * from "./multiconnect.vue?vue&type=script&lang=js&"
import style0 from "./multiconnect.vue?vue&type=style&index=0&id=1247b000&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports